
import { defineComponent } from 'vue';
import { IInvoice, IOrder } from '@/types/models';
import utils from '@/utils';
import api from '@/api/admin/orders';
import TableOrder from './components/orders/TableOrder.vue';
import TableInvoice from './components/orders/TableInvoice.vue';

interface IState {
  statusOrderDefault: string;
  statusOrderInvoiced: string;
  statusOrderRefunded: string;
  status: string;
  items: IOrder[];
  allCount: number;
  defaultCount: number;
  invoicedCount: number;
  refundedCount: number;
  order: IOrder;
  isTableOrder: boolean;
  invoice: IInvoice;
  isTableInvoice: boolean;
}

export default defineComponent({
  components: { TableOrder, TableInvoice },
  data() {
    return {
      statusOrderDefault: 'Default',
      statusOrderInvoiced: 'Invoiced',
      statusOrderRefunded: 'Refunded',
      status: this.$route.query.status || '',
      items: [],
      allCount: 0,
      defaultCount: 0,
      invoicedCount: 0,
      refundedCount: 0,
      order: {} as IOrder,
      isTableOrder: false,
      invoice: {} as IInvoice,
      isTableInvoice: false,
    } as IState;
  },
  methods: {
    apiGet() {
      api.get(
        {
          status: this.status,
        },
        (res) => {
          this.items = res.items;
          this.allCount = res.allCount;
          this.defaultCount = res.defaultCount;
          this.invoicedCount = res.invoicedCount;
          this.refundedCount = res.refundedCount;
        },
      );
    },

    apiRefund(order: IOrder) {
      api.refund(
        {
          orderId: order.guid,
        },
        (res) => {
          if (!res) return;
          utils.success('订单退款成功！');
          this.apiGet();
        },
      );
    },

    apiGetInvoice(order: IOrder) {
      api.getInvoice(
        {
          invoiceId: order.invoiceId,
        },
        (res) => {
          if (!res) return;
          this.invoice = res.invoice;
          this.isTableInvoice = true;
        },
      );
    },

    getOrderStatus(status: string) {
      if (status === this.statusOrderDefault) {
        return '待开发票';
      }
      if (status === this.statusOrderInvoiced) {
        return '已开发票';
      }
      if (status === this.statusOrderRefunded) {
        return '已退款';
      }
      return '待开发票';
    },

    getResourceType(item: IOrder) {
      return utils.getResourceType(item.resourceType);
    },

    getChannel(item: IOrder) {
      return utils.getPayChannel(item.channel);
    },

    getUrl(item: IOrder) {
      return utils.getResourceUrl(item.resourceType, item.resourceId);
    },

    btnNavClick() {
      this.apiGet();
    },

    btnOrderClick(order: IOrder) {
      this.order = order;
      this.isTableOrder = true;
    },

    btnRefundClick(order: IOrder) {
      utils.alertDelete(
        {
          title: '订单退款',
          text: `此操作将把订单${order.orderNo}全款退回并设置订单为已退款，确定吗？`,
          button: '确认退款',
        },
        () => {
          this.apiRefund(order);
        },
      );
    },
  },
  mounted() {
    this.apiGet();
  },
});
